import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { grantConsent, revokeConsent, hasConsent, initAnalytics, installGlobalTracking } from "../analytics/ga4";

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored = null;
    try {
      stored = localStorage.getItem("cil-analytics-consent");
    } catch {}
    if (!stored) {
      setVisible(true);
      document.body.dataset.consentOpen = "1";
      window.dispatchEvent(new CustomEvent("cil-consent", { detail: true }));
    }
    initAnalytics();
    installGlobalTracking();
  }, []);

  if (!visible) return null;

  const choose = (fn) => () => {
    fn();
    setVisible(false);
    document.body.dataset.consentOpen = "0";
    window.dispatchEvent(new CustomEvent("cil-consent", { detail: false }));
  };

  return (
    <div
      data-testid="cookie-consent"
      className="fixed inset-x-4 bottom-4 z-[90] border border-gold/30 bg-navy/95 p-5 shadow-2xl backdrop-blur md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md"
      role="dialog"
      aria-label="Cookie consent"
    >
      <p className="flex items-start gap-3 text-sm font-light leading-relaxed text-ivory/85">
        <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
        We use cookies to understand how visitors find and use this website — through
        Google Analytics and Google Ads. Accept and we&rsquo;ll measure; decline and they
        stay switched off.
      </p>
      <div className="mt-4 flex items-center gap-3">
        <button
          onClick={choose(grantConsent)}
          data-testid="cookie-accept-button"
          className="bg-gold px-6 py-2.5 text-[11px] font-semibold uppercase tracking-widest2 text-navy transition-colors hover:bg-gold-2"
        >
          Accept
        </button>
        <button
          onClick={choose(revokeConsent)}
          data-testid="cookie-decline-button"
          className="border border-ivory/25 px-6 py-2.5 text-[11px] font-semibold uppercase tracking-widest2 text-ivory/80 transition-colors hover:border-gold hover:text-gold-2"
        >
          Decline
        </button>
      </div>
    </div>
  );
}